/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  OutputText,
  OutputText$inboundSchema,
  OutputText$Outbound,
  OutputText$outboundSchema,
} from "./outputtext.js";
import {
  ReasoningText,
  ReasoningText$inboundSchema,
  ReasoningText$Outbound,
  ReasoningText$outboundSchema,
} from "./reasoningtext.js";
import {
  Refusal,
  Refusal$inboundSchema,
  Refusal$Outbound,
  Refusal$outboundSchema,
} from "./refusal.js";

export type Part =
  | (OutputText & { type: "output_text" })
  | (Refusal & { type: "refusal" })
  | (ReasoningText & { type: "reasoning_text" });

export type ResponseContentPartAddedEvent = {
  type: "response.content_part.added";
  sequenceNumber: number;
  itemId: string;
  outputIndex: number;
  contentIndex: number;
  part:
    | (OutputText & { type: "output_text" })
    | (Refusal & { type: "refusal" })
    | (ReasoningText & { type: "reasoning_text" });
};

/** @internal */
export const Part$inboundSchema: z.ZodType<Part, z.ZodTypeDef, unknown> = z
  .union([
    OutputText$inboundSchema.and(z.object({ type: z.literal("output_text") })),
    Refusal$inboundSchema.and(z.object({ type: z.literal("refusal") })),
    ReasoningText$inboundSchema.and(
      z.object({ type: z.literal("reasoning_text") }),
    ),
  ]);
/** @internal */
export type Part$Outbound =
  | (OutputText$Outbound & { type: "output_text" })
  | (Refusal$Outbound & { type: "refusal" })
  | (ReasoningText$Outbound & { type: "reasoning_text" });

/** @internal */
export const Part$outboundSchema: z.ZodType<Part$Outbound, z.ZodTypeDef, Part> =
  z.union([
    OutputText$outboundSchema.and(z.object({ type: z.literal("output_text") })),
    Refusal$outboundSchema.and(z.object({ type: z.literal("refusal") })),
    ReasoningText$outboundSchema.and(
      z.object({ type: z.literal("reasoning_text") }),
    ),
  ]);

export function partToJSON(part: Part): string {
  return JSON.stringify(Part$outboundSchema.parse(part));
}
export function partFromJSON(
  jsonString: string,
): SafeParseResult<Part, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => Part$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'Part' from JSON`,
  );
}

/** @internal */
export const ResponseContentPartAddedEvent$inboundSchema: z.ZodType<
  ResponseContentPartAddedEvent,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("response.content_part.added"),
  sequence_number: z.number().int(),
  item_id: z.string(),
  output_index: z.number().int(),
  content_index: z.number().int(),
  part: z.union([
    OutputText$inboundSchema.and(z.object({ type: z.literal("output_text") })),
    Refusal$inboundSchema.and(z.object({ type: z.literal("refusal") })),
    ReasoningText$inboundSchema.and(
      z.object({ type: z.literal("reasoning_text") }),
    ),
  ]),
}).transform((v) => {
  return remap$(v, {
    "sequence_number": "sequenceNumber",
    "item_id": "itemId",
    "output_index": "outputIndex",
    "content_index": "contentIndex",
  });
});
/** @internal */
export type ResponseContentPartAddedEvent$Outbound = {
  type: "response.content_part.added";
  sequence_number: number;
  item_id: string;
  output_index: number;
  content_index: number;
  part:
    | (OutputText$Outbound & { type: "output_text" })
    | (Refusal$Outbound & { type: "refusal" })
    | (ReasoningText$Outbound & { type: "reasoning_text" });
};

/** @internal */
export const ResponseContentPartAddedEvent$outboundSchema: z.ZodType<
  ResponseContentPartAddedEvent$Outbound,
  z.ZodTypeDef,
  ResponseContentPartAddedEvent
> = z.object({
  type: z.literal("response.content_part.added"),
  sequenceNumber: z.number().int(),
  itemId: z.string(),
  outputIndex: z.number().int(),
  contentIndex: z.number().int(),
  part: z.union([
    OutputText$outboundSchema.and(z.object({ type: z.literal("output_text") })),
    Refusal$outboundSchema.and(z.object({ type: z.literal("refusal") })),
    ReasoningText$outboundSchema.and(
      z.object({ type: z.literal("reasoning_text") }),
    ),
  ]),
}).transform((v) => {
  return remap$(v, {
    sequenceNumber: "sequence_number",
    itemId: "item_id",
    outputIndex: "output_index",
    contentIndex: "content_index",
  });
});

export function responseContentPartAddedEventToJSON(
  responseContentPartAddedEvent: ResponseContentPartAddedEvent,
): string {
  return JSON.stringify(
    ResponseContentPartAddedEvent$outboundSchema.parse(
      responseContentPartAddedEvent,
    ),
  );
}
export function responseContentPartAddedEventFromJSON(
  jsonString: string,
): SafeParseResult<ResponseContentPartAddedEvent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ResponseContentPartAddedEvent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ResponseContentPartAddedEvent' from JSON`,
  );
}
